export default {
	apiKey: "AIzaSyDM-2UzFhsUTUrVq4laBDJ8bDC3bvHKhYY",
	authDomain: "ares-uat-app.firebaseapp.com",
	databaseURL: "https://ares-uat-app.firebaseio.com",
	projectId: "ares-uat-app",
	storageBucket: "ares-uat-app.appspot.com",
	messagingSenderId: "75151380831",
	appId: "1:75151380831:web:1ad1573c1a8d1f332326ea",
	measurementId: "G-7HY2F3FD5G"
};